import { Flex, Radio, Typography } from "antd";
import { FC } from "react";
import { formatUAHStandard } from "tm-shared/utils";

import { PrimaryText } from "@/shared/ui/Typography";

import { CheckoutDiffItem, RemainingResolution } from "./CheckoutCard.types";

interface DiffItemProps {
    item: CheckoutDiffItem;
    resolution: RemainingResolution | undefined;
    onResolutionChange: (barcode: string, value: RemainingResolution) => void;
}

export const DiffItem: FC<DiffItemProps> = ({
    item,
    resolution,
    onResolutionChange,
}) => {
    const { barcode, productName, priceChanged, insufficientRemaining } = item;

    return (
        <Flex vertical gap={6}>
            <Typography.Text>
                {productName}{" "}
                <Typography.Text type="secondary">{barcode}</Typography.Text>
            </Typography.Text>

            {priceChanged && (
                <PrimaryText>
                    <b>Ціна змінилась:</b>{" "}
                    {formatUAHStandard(priceChanged.oldPrice)} →{" "}
                    {formatUAHStandard(priceChanged.newPrice)}
                </PrimaryText>
            )}

            {insufficientRemaining && (
                <Flex vertical gap={6}>
                    <PrimaryText type="danger">
                        <b>Недостатньо залишків:</b> у замовленні{" "}
                        {insufficientRemaining.orderedCount} шт., а доступно{" "}
                        {insufficientRemaining.remaining} шт.
                    </PrimaryText>

                    <Radio.Group
                        value={resolution}
                        onChange={(e) =>
                            onResolutionChange(barcode, e.target.value)
                        }
                    >
                        <Flex gap={4} wrap>
                            <Radio value={RemainingResolution.RemoveProduct}>
                                Видалити
                            </Radio>

                            {insufficientRemaining.remaining > 0 && (
                                <Radio
                                    value={
                                        RemainingResolution.ReduceToRemaining
                                    }
                                >
                                    Зменшити до{" "}
                                    {insufficientRemaining.remaining} шт.
                                </Radio>
                            )}

                            <Radio value={RemainingResolution.IgnoreRemaining}>
                                Ігнорувати
                            </Radio>
                        </Flex>
                    </Radio.Group>
                </Flex>
            )}
        </Flex>
    );
};
